const breadcrumb = (editor) => {

    editor.BlockManager.add(`breadcrumb`, {
        category: 'Components',
        label: `
          <svg id="Solid" width='1.4vw' height='1.4vw' viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m320 424a24 24 0 0 1 -16.971-40.971l127.03-127.029-127.03-127.029a24 24 0 0 1 33.942-33.942l144 144a24 24 0 0 1 0 33.942l-144 144a23.928 23.928 0 0 1 -16.971 7.029zm-119.029-7.029 144-144a24 24 0 0 0 0-33.942l-144-144a24 24 0 0 0 -33.942 33.942l127.03 127.029-127.03 127.029a24 24 0 0 0 33.942 33.942zm-136 0 144-144a24 24 0 0 0 0-33.942l-144-144a24 24 0 0 0 -33.942 33.942l127.03 127.029-127.03 127.029a24 24 0 0 0 33.942 33.942z"/></svg>
          <div class="gjs-fontFamily gjs-block-label">Breadcrumb</div>
          `,
        attributes: {},
        content: `
            <nav class="navbar grey-label">
              <div class="container-fluid" >                
                <ol class="breadcrumb" style="margin-bottom: 0px">
                  <li class="breadcrumb-item"><span href="#" class="pointer">Home</span></li>
                  <li class="breadcrumb-item"><span href="#" class="pointer">Library</span></li>
                  <li class="breadcrumb-item active" aria-current="page"><span class="pointer">Data</span></li>
                </ol>
              </div>
            </nav>
            `
      });

}

export default breadcrumb;